module.exports = __webpack_public_path__ + "download/img/openapp.daeaa1c6.png";